import * as types from './customViewActionType';

// Fetch Custom Views
export const fetchCustomViewsRequest = (payload) => ({
    type: types.FETCH_CUSTOM_VIEWS_REQUEST,
    payload
});

export const fetchCustomViewsSuccess = (payload) => ({
    type: types.FETCH_CUSTOM_VIEWS_SUCCESS,
    payload
});

export const fetchCustomViewsFailure = (payload) => ({
    type: types.FETCH_CUSTOM_VIEWS_FAILURE,
    payload
});

// Toggle Custom View Status
export const toggleCustomViewStatusRequest = (payload) => ({
    type: types.TOGGLE_CUSTOM_VIEW_STATUS_REQUEST,
    payload
});

export const toggleCustomViewStatusSuccess = (payload) => ({
    type: types.TOGGLE_CUSTOM_VIEW_STATUS_SUCCESS,
    payload
});

export const toggleCustomViewStatusFailure = (payload) => ({
    type: types.TOGGLE_CUSTOM_VIEW_STATUS_FAILURE,
    payload
});

// Delete Custom View
export const deleteCustomViewRequest = (payload) => ({
    type: types.DELETE_CUSTOM_VIEW_REQUEST,
    payload
});

export const deleteCustomViewSuccess = (payload) => ({
    type: types.DELETE_CUSTOM_VIEW_SUCCESS,
    payload
});

export const deleteCustomViewFailure = (payload) => ({
    type: types.DELETE_CUSTOM_VIEW_FAILURE,
    payload
});

// Fetch Rad Custom View
export const fetchRadCustomViewRequest = (payload) => ({
    type: types.FETCH_RAD_CUSTOM_VIEW_REQUEST,
    payload
});

export const fetchRadCustomViewSuccess = (payload) => ({
    type: types.FETCH_RAD_CUSTOM_VIEW_SUCCESS,
    payload
});

export const fetchRadCustomViewFailure = (payload) => ({
    type: types.FETCH_RAD_CUSTOM_VIEW_FAILURE,
    payload
});

// Fetch Custom View Share Dropdown in AddRadCustomViewModal
export const fetchCustomViewShareDropdownRequest = (payload) => ({
    type: types.FETCH_CUSTOM_VIEW_SHARE_DROPDOWN_REQUEST,
    payload
});

export const fetchCustomViewShareDropdownSuccess = (payload) => ({
    type: types.FETCH_CUSTOM_VIEW_SHARE_DROPDOWN_SUCCESS,
    payload
});

export const fetchCustomViewShareDropdownFailure = (payload) => ({
    type: types.FETCH_CUSTOM_VIEW_SHARE_DROPDOWN_FAILURE,
    payload
});

// Save Shared Custom View
export const saveSharedCustomViewRequest = (payload) => ({
    type: types.SAVE_SHARED_CUSTOM_VIEW_REQUEST,
    payload
});

export const saveSharedCustomViewSuccess = (payload) => ({
    type: types.SAVE_SHARED_CUSTOM_VIEW_SUCCESS,
    payload
});

export const saveSharedCustomViewFailure = (payload) => ({
    type: types.SAVE_SHARED_CUSTOM_VIEW_FAILURE,
    payload
});
// Request
export const getRadiologistAllDDListRequest = payload => ({
    type: types.GET_RADIOLOGIST_ALL_DD_LIST_REQUEST,
    payload
});

// Success
export const getRadiologistAllDDListSuccess = payload => ({
    type: types.GET_RADIOLOGIST_ALL_DD_LIST_SUCCESS,
    payload
});

// Failure
export const getRadiologistAllDDListFailure = payload => ({
    type: types.GET_RADIOLOGIST_ALL_DD_LIST_FAILURE,
    payload
});
export const saveRadCustomViewRequest = payload => ({
    type: types.SAVE_RAD_CUSTOM_VIEW_REQUEST,
    payload
});

export const saveRadCustomViewSuccess = payload => ({
    type: types.SAVE_RAD_CUSTOM_VIEW_SUCCESS,
    payload
});

export const saveRadCustomViewFailure = payload => ({
    type: types.SAVE_RAD_CUSTOM_VIEW_FAILURE,
    payload
});

export const saveRadCustomViewReset = () => ({
    type: types.SAVE_RAD_CUSTOM_VIEW_RESET
});
